/**
 * creditPacksCache — shared in-memory cache for credit packs.
 *
 * Pre-fetched in the background when entering a project so that
 * the ProjectCreditsIndicator dropdown opens instantly.
 */

import { listCreditPacks } from './visionBillingClient.js';

let _packs = null;
let _promise = null;

/** Fetch packs (deduplicates concurrent calls). */
export function loadCreditPacks() {
  if (_packs) return Promise.resolve(_packs);
  if (_promise) return _promise;
  _promise = listCreditPacks()
    .then((data) => { _packs = data; return data; })
    .catch(() => { _promise = null; return []; });
  return _promise;
}

/** Return cached packs synchronously (null if not yet loaded). */
export function getCachedCreditPacks() {
  return _packs;
}
